import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Heart } from 'lucide-react';
export function ResultsSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };
  const results = ['Entrás a su pieza y el ambiente ya no está tenso.', 'Las sesiones de discusiones eternas se terminaron.', 'Tu hijo propone sentarse en el sofá a contarte algo.', 'Los padres (o vos sola) están tranquilos porque ven un vínculo claro y reportes emocionales fluidos.'];
  return <section className="bg-white py-20 px-4 md:px-8 lg:px-16 relative overflow-hidden" data-id="element-137">
      {/* Decorative background element */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 opacity-5 pointer-events-none" data-id="element-138">
        <Heart className="absolute -top-20 -right-20 w-96 h-96 text-terracotta" data-id="element-139" />
        <Heart className="absolute -bottom-20 -left-20 w-96 h-96 text-rose" data-id="element-140" />
      </div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-141">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={containerVariants} className="text-center" data-id="element-142">
          <motion.h2 variants={itemVariants} className="text-3xl md:text-4xl font-serif font-bold text-terracotta mb-12" data-id="element-143">
            EL RESULTADO:
          </motion.h2>

          <div className="space-y-6" data-id="element-144">
            {results.map((result, index) => <motion.div key={index} variants={itemVariants} className="bg-cream/50 p-6 rounded-lg text-lg md:text-xl text-navy font-medium shadow-sm" data-id="element-145">
                {result}
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}